/* v1.23 How we label page. Reads the counts Liquid printed on the state picker's options; re-words, re-sorts, shows/hides. Never invents a number.
   State source = the site's own (window.TFPC_STATE, from the shopper's ZIP in tfpc.js). The picker can set it for shoppers with no ZIP by
   writing a ZIP-prefix for that state to tfpc_zip (the fallback tfpc.js already reads), then firing tfpc:zone so the rest of the page follows. */
(function () {
  var root = document.querySelector('[data-tfpc-labels]'); if (!root) return;
  var sel = root.querySelector('[data-lb-state]'); if (!sel) return;
  // first ZIP prefix of each state, same table tfpc.js uses (st())
  var ZIP = {MA:'010',RI:'028',NH:'030',ME:'039',VT:'050',CT:'060',NJ:'070',NY:'100',PA:'150',DE:'197',DC:'200',MD:'206',VA:'220',WV:'247',NC:'270',SC:'290',GA:'300',FL:'320',AL:'350',TN:'370',MS:'386',KY:'400',OH:'430',IN:'460',MI:'480',IA:'500',WI:'530',MN:'550',SD:'570',ND:'580',MT:'590',IL:'600',MO:'630',KS:'660',NE:'680',LA:'700',AR:'716',OK:'730',TX:'750',CO:'800',WY:'820',ID:'832',UT:'840',AZ:'850',NM:'870',NV:'889',CA:'900',HI:'967',OR:'970',WA:'980',AK:'995'};
  function g(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function s(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function zoneZip() { try { var z = JSON.parse(g('tfpc_zone') || 'null'); var zip = String((z && z.zip) || '').slice(0, 5); return /^\d{5}$/.test(zip) ? zip : ''; } catch (e) { return ''; } }
  function q(a) { return root.querySelectorAll(a); }
  function setText(a, t) { q(a).forEach(function (el) { el.textContent = t; }); }
  function nb(t) { return t.replace(/ (\S+)$/, ' $1'); } // no widows
  var nNV = +root.dataset.nnv || 0, nP = +root.dataset.np || 0;
  var page = '';   // state shown on this page (may differ from the site's when a ZIP says otherwise)

  function opt(c) { return c ? sel.querySelector('option[value="' + c + '"]') : null; }
  function name(c) { var o = opt(c); return o ? o.textContent : ''; }
  function plural(n, one, many) { return n === 1 ? one : many; }

  function pills(c, nm) {
    q('[data-ns-pill]').forEach(function (el) {
      if (!el.dataset.base) el.dataset.base = el.textContent;
      var on = !!c && (',' + el.getAttribute('data-ns') + ',').indexOf(',' + c + ',') >= 0;
      el.textContent = on ? (el.classList.contains('tfpc-wildtag--native-variety') ? nm + ' native variety' : 'Native to ' + nm) : el.dataset.base;
      el.classList.toggle('is-local', on);
    });
  }

  // Each strip: in-stock plants ranked in Liquid. Off-zone plants (tfpc.js marks their fit line .is-no) are swapped out, never greyed;
  // hand-picked cells (data-pick) lead; the Native row puts plants recorded wild in the chosen state first. First 3 that pass are shown.
  function strip(c) {
    q('[data-lb-strip]').forEach(function (box) {
      var cells = Array.prototype.slice.call(box.querySelectorAll('.tfpc-lb__cell'));
      if (!cells.length) return;
      cells.forEach(function (el, i) { if (el._i == null) el._i = i; });
      var loc = box.dataset.lbStrip === 'n';
      function rank(el) { var off = el.querySelector('[data-fit].is-no') ? 4 : 0; var l = loc && c && (',' + (el.dataset.ns || '') + ',').indexOf(',' + c + ',') < 0 ? 2 : 0; return off + l + (el.hasAttribute('data-pick') ? 0 : 1); }
      cells.sort(function (a, b) { return rank(a) - rank(b) || a._i - b._i; });
      var tile = box.querySelector('.tfpc-lb__more');
      cells.forEach(function (el, i) { box.insertBefore(el, tile); el.hidden = i > 2 || rank(el) >= 4; });
    });
  }

  function kits(c, nm) {
    var box = root.querySelector('[data-lb-kits]'); if (!box) return;
    var list = Array.prototype.slice.call(box.querySelectorAll('[data-kit]'));
    list.forEach(function (k) {
      var loc = 0, wt = +k.dataset.wt || 0;
      k.querySelectorAll('[data-st]').forEach(function (p) { var on = !!c && (',' + p.dataset.st + ',').indexOf(',' + c + ',') >= 0; p.classList.toggle('is-loc', on); if (on) loc++; });
      k._loc = loc;
      var t = k.querySelector('[data-kit-nat]');
      if (t) t.textContent = !c ? 'All ' + wt + ' native or native variety' : loc === 0 ? 'All ' + wt + ' native · none recorded wild in ' + nm : loc + ' of ' + wt + ' grow wild in ' + nm;
    });
    list.sort(function (a, b) { return c ? (b._loc - a._loc || a.dataset.i - b.dataset.i) : a.dataset.i - b.dataset.i; });
    list.forEach(function (k, i) { box.appendChild(k); k.hidden = i > 5; });
    var note = root.querySelector('[data-lb-kitnote]'); if (note) note.hidden = !c;
  }

  function render(c) {
    page = c || '';
    if (sel.value !== page) sel.value = opt(page) ? page : '';
    var o = opt(page), nm = o ? o.textContent : '';
    var k = o ? +o.dataset.k : 0, kn = o ? +o.dataset.kn : 0, kv = o ? +o.dataset.kv : 0, kp = o ? +o.dataset.kp : 0;
    var siteSt = window.TFPC_STATE || '';
    setText('[data-lb-name]', nm || 'your state');
    var line = root.querySelector('[data-lb-line]');
    if (line) {
      var t;
      if (!o) t = 'Pick your state, or set your ZIP anywhere on the site, to see what grows wild there.';
      else if (k === 0) t = 'None of our natives are recorded wild in ' + nm + ' yet. The labels still apply.';
      else t = k + ' ' + plural(k, 'plant', 'plants') + ' in our catalog ' + plural(k, 'grows', 'grow') + ' wild in ' + nm + '.';
      if (o && siteSt && siteSt !== page && zoneZip()) t += ' Your ZIP says ' + name(siteSt) + ', so the rest of the site still shows ' + name(siteSt) + '.';
      line.textContent = nb(t);
    }
    var cta = root.querySelector('[data-lb-cta]');
    if (cta) {
      if (o && k > 0) { cta.textContent = nb('Shop the ' + k + ' that grow wild in ' + nm + ' →'); cta.href = '/collections/native?f=ns:here'; }
      else { cta.textContent = nb('Shop all ' + nNV + ' natives and native varieties →'); cta.href = '/collections/native'; }
    }
    setText('[data-lb-kitslink]', o ? 'Kits for ' + nm + ' ↓' : 'Native kits ↓');
    setText('[data-lb-kitshead]', o ? 'Kits for ' + nm + '.' : 'Native kits.');
    setText('[data-lb-kitssub]', nb(o ? 'Every plant in these is native or a native variety. The number tells you how many grow wild in ' + nm + ' specifically.' : 'Every plant in these is native or a native variety. Set your state and we sort them by what grows wild there.'));
    var w = root.querySelector('[data-lb-wrong]');
    if (w) { if (o && k > 0) { w.textContent = 'Shop ' + nm + '’s natives →'; w.href = '/collections/native?f=ns:here'; } else { w.textContent = 'Shop the natives →'; w.href = '/collections/native'; } }
    q('[data-lb-rowlink]').forEach(function (a) {
      var n = a.dataset.lbRowlink === 'n' ? kn : kv, what = a.dataset.lbRowlink === 'n' ? plural(n, 'native', 'natives') : plural(n, 'native variety', 'native varieties');
      if (o && n > 0) { a.innerHTML = ''; a.appendChild(document.createTextNode(n + ' ' + what + ' grow wild in ' + nm + ' ')); a.href = a.dataset.href; }
      else if (o) { a.innerHTML = ''; a.appendChild(document.createTextNode('None recorded wild in ' + nm + ' yet ')); a.href = '#lb-state'; }
      else { a.innerHTML = ''; a.appendChild(document.createTextNode('Set your state to see what grows wild there ')); a.href = '#lb-state'; }
      var arr = document.createElement('span'); arr.className = 'n'; arr.textContent = '→'; a.appendChild(arr);
    });
    setText('[data-lb-localpill]', o ? 'Native to ' + nm : 'Native to your state');
    var take = root.querySelector('[data-lb-take]');
    if (take) {
      var tn = o ? nm : 'Ohio', tp = o ? kp : +take.dataset.oh;
      take.textContent = nb(tp > 0 ? 'Take ' + tn + ': ' + tp + ' of our perennials grow wild there, against ' + nP + ' that count as native somewhere on the continent. Shorter list, better bed.' : 'Take ' + tn + ': none of our perennials are recorded wild there yet, against ' + nP + ' that count as native somewhere on the continent.');
    }
    var per = root.querySelector('[data-lb-per]');
    if (per) {
      per.innerHTML = ''; per.appendChild(document.createTextNode(o && kp > 0 ? 'Perennials native to ' + nm + ' ' : 'Shop native perennials '));
      per.href = o && kp > 0 ? '/collections/perennials?f=ns:here' : '/collections/perennials?f=native';
      var a2 = document.createElement('span'); a2.className = 'n'; a2.textContent = '→'; per.appendChild(a2);
    }
    var f = root.querySelector('[data-tfpc-sub="labels"]'); if (f) f.dataset.props = JSON.stringify(o ? { tfpc_state: page } : {});
    pills(page, nm);
    strip(page);
    kits(page, nm);
  }

  function siteState() { return window.TFPC_STATE || (zoneZip() ? '' : (g('tfpc_state') || '')); }

  sel.addEventListener('change', function () {
    var c = sel.value;
    s('tfpc_state', c || null);
    if (!zoneZip()) s('tfpc_zip', c && ZIP[c] ? ZIP[c] + '01' : null); // no ZIP of their own: let tfpc.js know the state
    render(c);
    try { window.dispatchEvent(new Event('tfpc:zone')); } catch (e) {}
    setTimeout(function () { render(c); }, 0); // tfpc.js re-labels pills from its own state; put ours back if they differ
    if (c) {
      try { window.TFPC && window.TFPC.track && window.TFPC.track('Set State', { tfpc_state: c, Page: location.pathname }); } catch (e) {}
      try { var em = g('tfpc_email'); if (em && window.TFPC && window.TFPC.identify) window.TFPC.identify(em, { tfpc_state: c }); } catch (e) {}
    }
  });
  // the shopper sets a ZIP from the header while here: follow the site
  window.addEventListener('tfpc:zone', function () { setTimeout(function () { var st = window.TFPC_STATE || ''; if (st && st !== page && zoneZip()) render(st); else strip(page); }, 0); });
  root.addEventListener('click', function (e) { var a = e.target.closest('a[href="#lb-state"]'); if (!a) return; e.preventDefault(); sel.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { sel.focus(); }, 300); });
  render(siteState());
})();
